<template>
    <div style="position: relative" @focusin="hasFocus = true">
        <div class="input-group md-form form-sm form-1 pl-0">
            <div class="input-group-prepend">
                <span class="input-group-text">
                    <i
                        :class="{
                            fas: true,
                            'fa-search': !loading && !typing,
                            'fa-ellipsis-h': !loading && typing,

                            'fa-spin': loading,
                            'fa-sync': loading,
                        }"
                        aria-hidden="true"
                    ></i>
                </span>
            </div>
            <input
                class="form-control my-0 py-1"
                type="search"
                :placeholder="placeholder || 'Search'"
                :aria-label="placeholder || 'Search'"
                :disabled="disabled"
                :required="required"
                v-model="query"
                :name="name"
                :id="name"
                @keyup.prevent="onKeyUp"
                @keydown.enter.prevent="onEnterUp"
                data-lpignore="true"
            />
            <slot name="append"></slot>
        </div>

        <div
            class="autocomplete-container dropdown-menu w-100"
            :style="autocompleteCss"
            v-if="hasFocus && !loading && suggestions && suggestions.length > 0"
        >
            <slot
                v-for="item in suggestions"
                :item="item"
                :defocus="defocus"
                :query="query"
            ></slot>
        </div>
        <div
            class="autocomplete-container dropdown-menu w-100"
            v-else-if="hasFocus && !loading && '' !== query && lastQuery"
        >
            <p class="text-center text-muted mb-0">No results...</p>
            <slot name="noresults" :query="query"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "ApiSearch",

    props: {
        route: {
            required: true,
            type: String,
        },

        initialQuery: {
            required: false,
            type: String,
        },

        autocompleteCss: {
            required: false,
            type: String,
        },

        required: {
            required: false,
            type: Boolean,
        },

        disabled: {
            required: false,
            type: Boolean,
        },

        placeholder: {
            required: false,
            type: String,
        },

        name: {
            required: false,
            type: String,
            default: "_search",
        },
    },

    data() {
        return {
            loading: this.initialQuery ? true : false,
            typing: false,
            hasFocus: false,

            query: this.initialQuery || "",

            lastQuery: null,
            suggestions: null,
        };
    },

    computed: {},

    methods: {
        onQuery(fresh) {
            let query = this.query.trim();

            if (this.lastQuery === query && true !== fresh) {
                return;
            }
            this.lastQuery = query;
            this.loading = true;

            axios
                .post("/api/" + this.route, {
                    query: query,
                })
                .then((response) => {
                    // console.log(response);
                    this.loading = false;

                    let data = response.data;
                    if (!data.success) {
                        $("#fail-alert")
                            .text(data.message || "Unknown error")
                            .slideDown(200)
                            .delay(5000)
                            .slideUp(200);
                    } else {
                        this.suggestions = data.suggestions;
                    }
                })
                .catch((error) => {
                    console.error(error.response);
                    this.loading = false;

                    $("#fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(200)
                        .delay(5000)
                        .slideUp(200);
                });
        },

        debounceTyping: _.debounce(function () {
            this.typing = false;
            this.onQuery();
        }, 500),

        debounceTypingFresh: _.debounce(function () {
            this.typing = false;
            this.onQuery(true);
        }, 500),

        onKeyUp() {
            this.typing = true;
            this.debounceTyping();
        },

        onEnterUp() {
            this.typing = true;
            this.debounceTypingFresh();
        },

        handleClickFocusing(event) {
            if (!this.$el.contains(event.target)) {
                this.hasFocus = false;
            }
        },

        defocus(query = null) {
            this.hasFocus = false;

            if (null !== query) {
                this.query = query;
            }
        },
    },

    watch: {},

    mounted() {
        document.addEventListener("click", this.handleClickFocusing);

        if (this.initialQuery) {
            this.onQuery();
        }
    },
};
</script>
